import { useRouter } from "next/router";
import { useState } from "react";
import "swiper/css";
import { Swiper, SwiperClass, SwiperSlide } from "swiper/react";

import { useMediaQueryBreakpoint } from "@hooks";

import { referals } from "./content";
import { ReferalsContainer } from "./Referals.styled";
import { ReferalsButton } from "./ReferalsButton";
import { ReferelBody } from "./ReferealBody";

interface ReferalsProps {
  className?: string;
}

export const Referals = ({ className }: ReferalsProps) => {
  const [swiper, setSwiper] = useState<SwiperClass | null>(null);
  const [, setSlideIndex] = useState(0);

  const { isTablet } = useMediaQueryBreakpoint();
  const { locale } = useRouter();

  const mappedReferals = referals.map(referal =>
    locale === "en" ? referal.en : referal.pl,
  );

  return (
    <ReferalsContainer className={className}>
      {isTablet && (
        <ReferalsButton
          onClick={() => swiper?.slidePrev()}
          disabled={swiper?.isBeginning}
          flip
        />
      )}
      <Swiper
        spaceBetween={50}
        slidesPerView={1}
        onSwiper={swiper => setSwiper(swiper)}
        onSlideChange={swiper => setSlideIndex(swiper.activeIndex)}
      >
        {mappedReferals.map((referal, index) => (
          <SwiperSlide key={index}>
            <ReferelBody
              title={referal.title}
              author={referal.author}
              company={referal.company}
            >
              {referal.body}
            </ReferelBody>
          </SwiperSlide>
        ))}
      </Swiper>
      {isTablet && (
        <ReferalsButton
          onClick={() => swiper?.slideNext()}
          disabled={swiper?.isEnd}
        />
      )}
    </ReferalsContainer>
  );
};
